import { en } from './en';

export const vi = {
    COMMON: {
        ...en.COMMON,
        HHCCN: {
            LANGUAGE: {
                SECTION_TITLE: 'Ngôn ngữ',
            },
            CHANGES: {
                SECTION_TITLE: 'Thông báo Thay đổi Dịch vụ Chăm sóc Sức khỏe tại Tư gia (HHCCN)',
                FIELD1: 'Những khoản mục/dịch vụ nào sẽ thay đổi?',
                FIELD2: 'Lý do thay đổi',
                ADD_ITEM: 'Thêm mục',
            },
            STARTING_DATE: {
                SECTION_TITLE: 'Ngày bắt đầu',
                LABEL: 'Ngày bắt đầu thay đổi',
            },
            NOTICE_REASON: {
                SECTION_TITLE: 'Tại sao quý vị nhận được thông báo này?',
                OPTION1: {
                    LABEL: 'Bác sĩ/nhà cung cấp dịch vụ chăm sóc sức khỏe tại tư gia của quý vị đã thay đổi (hoặc không gia hạn) yêu cầu chăm sóc sức khỏe tại tư gia của quý vị.',
                    DESCRIPTION:
                        'Cơ quan chăm sóc sức khỏe tại tư gia phải tuân theo yêu cầu của bác sĩ/nhà cung cấp dịch vụ trong việc chăm sóc quý vị. Nếu quý vị không đồng ý với thay đổi này, hãy thảo luận với cơ quan chăm sóc sức khỏe tại tư gia hoặc bác sĩ/nhà cung cấp dịch vụ đã được yêu cầu chăm sóc tại tư gia cho quý vị.',
                },
                OPTION2: {
                    LABEL: 'Cơ quan chăm sóc sức khỏe tại tư gia quyết định ngừng cung cấp cho quý vị các khoản mục/dịch vụ vì những lý do được liệt kê ở trên.',
                    DESCRIPTION:
                        'Nếu quý vị nghĩ rằng mình vẫn cần được chăm sóc tại tư gia, quý vị có thể tìm dịch vụ chăm sóc từ một cơ quan chăm sóc sức khỏe tại tư gia khác nếu quý vị có yêu cầu hợp lệ. Để được trợ giúp tìm một cơ quan chăm sóc sức khỏe tại tư gia khác, hãy liên hệ với bác sĩ/nhà cung cấp dịch vụ đã được yêu cầu chăm sóc tại tư gia cho quý vị. Nếu quý vị nhận được dịch vụ chăm sóc từ một cơ quan chăm sóc sức khỏe tại tư gia khác, quý vị có thể yêu cầu cơ quan đó lập hóa đơn cho Medicare.',
                },
            },
            GET_HELP: {
                SECTION_TITLE: 'Nhận trợ giúp hoặc thông tin thêm',
                CONTENT:
                    'Nếu quý vị có thắc mắc về những thay đổi này, hãy liên hệ với cơ quan chăm sóc sức khỏe tại tư gia của quý vị và/hoặc bác sĩ/nhà cung cấp dịch vụ đã được yêu cầu chăm sóc tại tư gia cho quý vị. Quý vị không thể kháng cáo lên Medicare về khoản thanh toán cho các mặt hàng/dịch vụ được liệt kê ở trên trừ khi quý vị nhận được các mặt hàng/dịch vụ đó và đã nộp yêu cầu bồi thường Medicare.',
            },
            OPTIONAL_DETAILS: {
                SECTION_TITLE: 'Chi tiết tùy chọn',
            },
            PATIENT_SIGNATURE: {
                SECTION_TITLE: 'Chữ ký',
                HEADING: 'Ký tên bên dưới để thể hiện việc quý vị hiểu thông báo này',
                AGREE: 'Bệnh nhân hoặc đại diện được ủy quyền đồng ý ký điện tử vào tài liệu này bằng cách chọn hộp này.',
                AUTHORIZED_REP:
                    'Đánh dấu vào đây nếu quý vị đang ký tên với tư cách là Đại diện được Ủy quyền và đảm bảo tên của quý vị dễ đọc hoặc viết in hoa tên của quý vị, nếu không dễ đọc.',
            },
            ACCESSIBILITY: {
                CONTENT:
                    'Quý vị có quyền nhận thông tin của mình ở định dạng dễ tiếp cận, như bản in chữ lớn, chữ nổi Braille, hoặc audio. Quý vị cũng có quyền nộp đơn khiếu nại nếu quý vị cảm thấy mình bị phân biệt đối xử. Truy cập Medicare.gov/about-us/accessibility-nondiscrimination-notice, hoặc gọi 1-800-MEDICARE (1-800-633-4227) để biết thêm thông tin. Người dùng TTY có thể gọi 1-877-486-2048.',
            },
        },
    },
};
